import { createImmutableMap } from 'ctm-util-functions';

/**
 * Reducer for setting visibility on field sets.
 * @param {Object} initialState - The initial state.
 * @param  {String} stateKey  The state key that this reducer should process actions for
 * @returns {Function} The visibility reducer
 */

const allowedActions = ['SHOW_FIELD_SET', 'HIDE_FIELD_SET'];

const createFieldSetVisibilityReducer = (initialState = {}, stateKey) => {
    const immutableInitialState = createImmutableMap(initialState);
    return (state = immutableInitialState, action) => {
        if (allowedActions.includes(action.type) && !action.stateKey) {
            throw new Error(`Action sent to visibility reducer has no stateKey: ${JSON.stringify(action)}`);
        }
        if (action.stateKey !== stateKey) {
            return state;
        }
        switch (action.type) {
            case 'SHOW_FIELD_SET': {
                return state.set(action.fieldSet, true);
            }
            case 'HIDE_FIELD_SET': {
                return state.set(action.fieldSet, false);
            }
            default: {
                return state;
            }
        }
    };
};

export { createFieldSetVisibilityReducer };
